import errorManager from '@/rollbar.js';

const listenerFilledTable = function () {
  eventBus.$on('filledTable', () => {
    let gridTable = $('#jqgrid-guest-activity-all tr');
    canMarkAsDone(gridTable);
    if (gridTable.length > 1) {
      let fromDate = moment($('#params_from').val()).toDate();
      const today = new Date();
      disableRows(fromDate, today, gridTable.length);
    }
  });
};

const disableRows = function (fromDate, today) {
  let futureRegistration = $('#future_registration').val() == 'true';
  const inputsToDisable = [
    'guest_activity_all_status',
    'guest_activity_all_motivation',
    'guest_activity_all[war]',
    'guest_activity_all[duration]',
  ];
  if (fromDate > today && futureRegistration) {
    const inputs = document.querySelectorAll('#jqgrid-guest-activity-all .editable');
    inputs.forEach((el) => {
      if (inputsToDisable.includes(el.name)) {
        el.disabled = true;
      }

      const done = document.querySelector('#execute_all_guest_activity_result');
      done.disabled = true;
    });
  }
};

const canMarkAsDone = function (gridTable) {
  gridTable.each(function () {
    let inputs = $(this).find('.editable');
    const inputsToDisable = [
      'guest_activity_all_status',
      'guest_activity_all_motivation',
      'guest_activity_all[war]',
      'guest_activity_all[duration]',
    ];
    let canMark = false;

    inputs.each(function () {
      if (this.name == 'is_within_time_tolerance?') {
        canMark = this.value == 'false';
      }

      if (canMark && inputsToDisable.includes(this.name)) {
        this.disabled = true;
      }
    });
  });
};

const init = () => {
  () => {
    return window.i18nJS;
  };

  try {
    listenerFilledTable();
  } catch (e) {
    errorManager(e);
  }
};

window.ProtectionControl = {
  init: init,
};
